var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[(_vm.hasMessages)?_vm._l((_vm.messages),function(message,idx){return _c('MessageItem',{key:message.id,attrs:{"message":message,"last":idx === _vm.messages.length - 1}})}):_c('li',[_vm._v("There are no messages yet.")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }